module.exports = __webpack_public_path__ + "img/Dashboard.1080e95f.png";